import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import {get, set, unset} from "lodash";
import TreeMenuNewList from "./TreeMenuNewList";
import {useTreeMenuNew} from "./TreeMenuNewContext";
import classnames from "classnames";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";
import {DISPLAY_TYPE_BREADCRUMB, DISPLAY_TYPE_TREE} from "./TreeMenuNew";

const TreeMenuNewItem = props => {
  const {setActives, isMulti, displayType} = useTreeMenuNew()
  const [activeItemKey, setActiveItemKey] = useState()

  useAfterUpdateEffect(() => {
    if(props.item.acctive && activeItemKey !== props.item.key){
      setActiveItemKey(props.item.key)
      if(props.item.onShowFn){
        props.item.onShowFn(props.item)
      }
    }
  }, [props.item])

  const Tag = props.item.path ? Link : 'div'

  return <React.Fragment>
    <Tag
      to={(!props.item.loading && props.item.path) ? ((props.item.path?.toString() || '') + '/') : false}
      className={classnames({
        'cursor-pointer list-group-item-action list-group-item': true,
        'bg-primary text-white': props.item.acctive && (props.item?.items?.length > 0 || !!props.item?.component),
        'd-none item-hidden': props.item.acctive && displayType === DISPLAY_TYPE_BREADCRUMB,
      })}
      onClick={() => {
        if(props.item.loading){
          return
        }
        if(props.item.onClick){
          props.item.onClick(props.item)
        }
        const path = props.item.idsPath.map(id => `id-${id}`).join('.')

        setActives(actives => {
          if(!isMulti){
            if(get(actives, path)){
              actives = {}
            }else{
              actives = {}
              set(actives, path, true)
            }
          }else{
            if(get(actives, path)){
              unset(actives, path)
            }else{
              set(actives, path, true)
            }
          }


          return {
            ...actives
          }
        })
      }}
    >
      <div className="d-flex flex-row flex-nowrap align-items-center">
        {displayType === DISPLAY_TYPE_TREE && <div style={{width: 12}}>
          {((props.item?.items?.length > 0 || props.item?.component) && !props.item.acctive) && <i className="fas fa-angle-right"/>}
          {((props.item?.items?.length > 0 || props.item?.component) && props.item.acctive) && <i className="fas fa-angle-down"/>}
        </div>}
        <span>{props.item.label}</span>
      </div>
    </Tag>
    {props.item.acctive && <React.Fragment>
      {props.item?.items?.length > 0 && <TreeMenuNewList
        items={props.item.items}
      />}
      {typeof props.item?.component === 'function' && <props.item.component {...props.item.componentProps} />}
      {typeof props.item?.component === 'object' && props.item.component}
    </React.Fragment>}
  </React.Fragment>
};

TreeMenuNewItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    acctive: PropTypes.bool.isRequired,
    path: PropTypes.string,
    idsPath: PropTypes.arrayOf(PropTypes.number),
    label: PropTypes.any.isRequired,
    component: PropTypes.any,
    componentProps: PropTypes.object,
    onShowFn: PropTypes.func,
    onClick: PropTypes.func,
  }).isRequired,
};

export default TreeMenuNewItem;